"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const StyledToggleChip = (0, styled_components_1.default)(ToggleButton_1.default) `
  label {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 16px;
    text-transform: none;
    pointer-events: none;
    text-align: center;
    line-height: 1;
    text-align: left;
  }

  &.MuiToggleButton-root {
    width: auto;
    justify-content: center;
    margin: 8px;
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    background-color: ${({ theme }) => theme.palette.gray[0]};
    border: 1px solid transparent;
    border-radius: 30px !important;
    padding: 16px 24px;

    &:hover {
      background-color: ${({ theme }) => theme.palette.gray[10]};
    }

    &.Mui-focusVisible {
      box-shadow: ${({ theme }) => `0 0 10px 0 ${theme.palette.primary.main}, 0 0 5px 0 ${theme.palette.primary.main}`};
    }

    &.Mui-selected {
      &,
      & + .MuiToggleButton-root.Mui-selected {
        border: ${({ theme }) => `1px solid ${theme.palette.status.success}`};

        &:hover {
          background-color: ${({ theme }) => theme.palette.gray[10]};
        }
      }
    }
    &[data-error="true"] {
      border-color: ${({ theme }) => `${theme.palette.status.error} !important`};
    }
  }
`;
/** A selectable chip */
function ToggleChip({ hasError, label, ...rest }) {
    const id = (0, uniqueId_1.default)();
    return ((0, jsx_runtime_1.jsx)(StyledToggleChip, { "aria-label": label, "data-error": !!hasError, disableFocusRipple: true, id: id, ...rest, children: (0, jsx_runtime_1.jsx)("label", { htmlFor: id, children: label }) }));
}
exports.default = ToggleChip;
//# sourceMappingURL=index.js.map